
import { Vue, Component, Prop } from "vue-property-decorator";
import {INumberIndexedObject} from "@/components/proptypes/INumberIndexedObject";
import {ITab} from "@/components/proptypes/ITab";

@Component
export default class vTabbedContent extends Vue {
  @Prop({ default: 1 }) startTab: number;
  @Prop() tabs!: ITab[];

  active: number = 1;
  errorTabs: INumberIndexedObject = {};

  // fliter tabs that are meant to be null (not rendered)
  get filteredTabs() {
    return this.tabs.filter((tab) => !tab.predicate || tab.predicate());
  }

  changeTab(tabId: number) {
    this.active = tabId;
  }

  created() {
    this.active = this.startTab;
    // Map a validator for any children which may be part of a form
    this.$validator = this.$parent.$validator;
    this.errorTabs = this.tabs.reduce<ITab>((acc, tab) => {
      acc[tab.id] = false;
      return acc;
    }, this.tabs[0]);
  }

  setErrorTab(tabId: number, error: boolean) {
    this.errorTabs[tabId] = error;
  }
}
